import Component from '@glimmer/component';
import type DeviceModel from 'garaje/models/device';

interface GlobalDevicesIpadsIpadTableComponentSignature {
  Args: {
    ipads: DeviceModel[];
    sortDirection: string;
    setSortDirection: (direction: string) => void;
    setSortBy: (sortBy: string) => void;
    sortBy: string;
    selectedIPads: DeviceModel[];
    unselectIPad: (ipad: DeviceModel) => void;
    clearSelectedIPads: () => void;
    selectIPad: (ipad: DeviceModel) => void;
    selectAllIPads: () => void;
  };
}

export default class GlobalDevicesIpadsIpadTableComponent extends Component<GlobalDevicesIpadsIpadTableComponentSignature> {
  get isSelectAllIndeterminate(): boolean {
    const selectedCount = this.args.selectedIPads.length;
    return selectedCount > 0 && !this.isSelectAll;
  }

  get isSelectAll(): boolean {
    const selectedCount = this.args.selectedIPads.length;
    const iPadCount = this.args.ipads.length;
    return iPadCount === selectedCount;
  }
}
